
import { Prop } from 'vue-property-decorator'
import { Vue, Options } from 'vue-class-component'
import LoadingButton from '../loading-button/loading-button.vue'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'
import { getOrderArrayByNumber } from '@/helpers/orderArray'
import ModalBottomOptions, { ReasonList } from '@/interfaces/modal-bottom-options'

import QInput from 'quasar/src/components/input/QInput.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import { useStore } from '@/store'

@Options({
  components: {
    LoadingButton,
    QInput,
    QCheckbox
  }
})
export default class ModalBottom extends Vue {
  @Prop() modalOptions!: ModalBottomOptions
  @Prop() onClose!: () => void
  @Prop() isInProgress!: boolean
  store = useStore()

  private reasonList: ReasonList[] = []
  private active = true
  private selectedReasonList: ReasonList[] = []
  private otherTextMap: any = {}
  private otherPreviosTextMap: any = {}

  async created() {
    await this.getReasonList()
  }

  get idToken() {
    return this.store.state.lineInfo.idToken
  } 

  mounted() {
    this.setOpacity()
  }

  setOpacity() {
    const modalElement = document.getElementsByClassName('dummy-background')[0]! as HTMLElement

    setTimeout(() => {
      modalElement.style.opacity = '0.7'
    }, 10)
  }

	closeModal() {
    const dialogElement = document.getElementsByClassName('modal-dialog')[0]! as HTMLElement
    const modalElement = document.getElementsByClassName('dummy-background')[0]! as HTMLElement

    dialogElement.style.bottom = '-100%'
    modalElement.style.opacity = '0'

    setTimeout(() => {
      this.onClose()
    }, 500)
	}

  async getReasonList() {
    const token = this.idToken

    if (token) {
      const result = await meService.getUnlinkReasons(token)
      const statusCode = result.httpStatusCode

      if (statusCode === 200) { 
        const items: [] = result.json.data

        if(items.length > 0) {
          this.reasonList = getOrderArrayByNumber(items, 'order')
        }
      } else {
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    }
  }

  handleSubmitModal(actionFn: (payload: any) => void) {
    const reasons = this.selectedReasonList.map((reason) => {
      const data: ReasonList = {
        reason_code: reason['reason_code'],
        group_code: reason['group_code'],
        text_th: reason['text_th'],
        text_en: reason['text_en'],
        is_required_other_text: reason['is_required_other_text'],
        order: reason['order']
      }

      if (data['is_required_other_text']) {
        const otherTextKey = `${reason['group_code']}-${reason['reason_code']}`

        data['other_text'] = this.otherTextMap[otherTextKey]
      }
      
      return data
    })

    return actionFn({ reasonList: reasons })
  }

  isFormDisabled() {
    if (!this.selectedReasonList.length) return true
    if (!this.validateOtherText()) return true
  }

  validateOtherText() {
    const otherTextKeyList = this.selectedReasonList.map((reason) => {
      if (reason['is_required_other_text']) return `${reason['group_code']}-${reason['reason_code']}`

      return ''
    }).filter(Boolean)

    for (let i = 0; i < otherTextKeyList.length; i += 1) {
      const key = otherTextKeyList[i]

      if (!this.otherTextMap[key]) return false
    }

    return true
  }

  handleToggleCheckbox(reason: ReasonList) {
    if (reason['is_required_other_text']) {
      this.$nextTick(() => {
        const modalOptionRef: any = this.$refs['modalOption']
        const otherTextInputRef: any = this.$refs[`otherTextInput-${reason['group_code']}-${reason['reason_code']}`]

        if (otherTextInputRef && otherTextInputRef.length) {
          const el = otherTextInputRef[0].getNativeElement() as HTMLElement
          const labelEl = el.closest('label.q-field') as HTMLElement
          const labelContainerEl = labelEl?.parentElement as HTMLElement

          if (labelEl) {
            const labelPadding = parseFloat(window.getComputedStyle(labelContainerEl, null).getPropertyValue('padding-bottom'))
            const offset = labelEl.offsetTop + labelEl.clientHeight + labelPadding
            const targetY = offset - modalOptionRef.offsetHeight
            const isVisible = targetY <= modalOptionRef.scrollTop

            if (!isVisible) {
              const duration = 200
              const currentY = modalOptionRef.scrollTop
              const diffY = targetY - currentY
              let startTimeStamp: number

              const smoothScroll = (timestamp: number) => {
                if (!startTimeStamp) {
                  startTimeStamp = timestamp
                }
                const elapsed = timestamp - startTimeStamp
                const percentage = elapsed / duration

                modalOptionRef.scrollTo({ top: currentY + (diffY * percentage) })

                if (percentage < 1) {
                  window.requestAnimationFrame(smoothScroll)
                }
              }
              
              window.requestAnimationFrame(smoothScroll)
            }
          }
        }
      })
    }
  }

  handleUpdateInput(reason: ReasonList) {
  let otherText = this.otherTextMap[`${reason['group_code']}-${reason['reason_code']}`]
  let previousText = this.otherPreviosTextMap[`${reason['group_code']}-${reason['reason_code']}`]

  if (otherText?.length > 200) {
      this.otherTextMap[`${reason['group_code']}-${reason['reason_code']}`] = previousText
      return
    }

  this.otherPreviosTextMap[`${reason['group_code']}-${reason['reason_code']}`] = otherText
  }
}
